import { types } from 'mobx-state-tree';

export default types
  .model('SignupDialogState', {
    shouldDisplayForm: false,
    shouldDisplayVerification: false,
  })
  .actions(self => ({
    showForm() {
      self.shouldDisplayForm = true;
    },
    showVerification() {
      self.shouldDisplayVerification = true;
    },
  }));
